import APIService from '@/services/APIService.js';

export default {
  getAllValidacoes(includeExpiredRecords) {
    return APIService.apiCall().get(`/ValidadorContabil/getAllValidacoes/${includeExpiredRecords}`);
  },
  getValidacao(id) {
    return APIService.apiCall().get(`/ValidadorContabil/getValidacao/${id}`);
  },
  salvar(postData) {
    return APIService.apiCall().post(`/ValidadorContabil/salvar/${postData.id}`, JSON.stringify(postData));
  },
  deletar(id) {
    return APIService.apiCall().get(`/ValidadorContabil/excluir/${id}`);
  },
  executar(id) {
    return APIService.apiCall().get(`/ValidadorContabil/executar/${id}`);
  },
  download(id, config = {}) {
    return APIService.apiCall().get(`/ValidadorContabil/downloadArquivoResultado/${id}`, { responseType: 'blob', ...config });
  },
  andamento(id) {
    return APIService.apiCall().get(`/ValidadorContabil/andamento/${id}`);
  }
};
